import Cookies from 'js-cookie'
/**
 * 是否保留路由
 * return true保留 false去除
 */
export const handleKeepRoute = (route, userInfo) => {
  const role = (route.meta && route.meta.role) || []
  // userType: 1主账号, 2子账号
  const userType = userInfo.userType
  // corpCertificationStatus: 企业认证状态, -1=未认证, 0=认证审核中, 1=已认证, 2=认证未通过
  const corpCertificationStatus = userInfo.corpCertificationStatus
  let loginType = Cookies.get('loginType')
  // 团队队员登录只显示needMember菜单
  if (loginType === 'member') {
    return route.name === 'layout' || role.needMember
  } else if (role.needMember) {
    return false
  }
  if (role.needMainUser && userType !== 1) {
    return false
  }
  if (role.needVerified && corpCertificationStatus !== 1) {
    return false
  }
  return true
}

/**
 * meta.role:
 * needMainUser=true:只有主账号才能访问，子账号不能访问，false或者undefined无限制
 * needVerified=true:只有认证用户才能访问，非认证用户不能访问，false或者undefined无限制
 */
export default [
  {
    name: 'layout',
    path: '/corporation/layout/index',
    meta: {role: {}},
    children: [
      // 首页
      {
        name: 'dashboard',
        path: '/corporation/home/dashboard',
        meta: {role: {}}
      },
      {
        name: 'memberTimeCardManage',
        path: '/corporation/member/time-card/index',
        meta: {role: {needMember: true}}
      },

      // 微信应用
      {
        name: 'wechatAppHome',
        path: '/corporation/wechat/index',
        meta: {role: {needVerified: true}}
      },
      {
        name: 'wechatAppList',
        path: '/corporation/wechat/list',
        meta: {role: {needVerified: true}}
      },
      {
        name: 'wechatAppCoupon',
        path: '/corporation/wechat/coupon/index',
        meta: {role: {needVerified: true}}
      },
      {
        name: 'wechatAppReport',
        path: '/corporation/wechat/monitor/index',
        meta: {role: {needVerified: true}}
      },
      {
        name: 'wechatAppShareProfit',
        path: '/corporation/wechat/share-profit/index',
        meta: {role: {needVerified: true}}
      },
      {
        name: 'wechatAppTeamManage',
        path: '/corporation/wechat/team/index',
        meta: {role: {needVerified: true}}
      },
      {
        name: 'wechatAppTeamDetail',
        path: '/corporation/wechat/team/TeamInfoDetail',
        meta: {role: {needVerified: true}}
      },
      {
        name: 'TeamCheckRecordList',
        path: '/corporation/wechat/team/TeamCheckRecordList',
        meta: {role: {needVerified: true}}
      },
      {
        name: 'corporationInfoAppResultConfig',
        path: '/corporation/info/appResultConfig/appResultConfig',
        meta: {role: {needVerified: true}}
      },
      {
        name: 'corporationInfoAppResultConfigManage',
        path: '/corporation/info/appResultConfig/appResultConfigIndex',
        meta: {role: {needVerified: true}}
      },
      {
        name: 'showBaseInfo',
        path: '/corporation/wechat/info/show',
        meta: {role: {needVerified: true}}
      },
      {
        name: 'wechatBaseInfo',
        path: '/corporation/wechat/info/index',
        meta: {role: {needVerified: true}}
      },
      {
        name: 'bandWeChat',
        path: '/corporation/wechat/band/index',
        meta: {role: {needVerified: true}}
      },
      {
        name: 'bandWeChatMp',
        path: '/corporation/wechat/band/mp/index',
        meta: {role: {needVerified: true}}
      },
      {
        name: 'bandWePluginMp',
        path: '/corporation/wechat/band/mp/plugin',
        meta: {role: {needVerified: true}}
      },
      {
        name: 'harmonyBindConf',
        path: '/corporation/wechat/band/harmony/index',
        meta: {role: {needVerified: true}}
      },
      {
        name: 'eedsBindConf',
        path: '/corporation/wechat/band/eeds/index',
        meta: {role: {needVerified: true}}
      },
      {
        name: 'showBandInfo',
        path: '/corporation/wechat/band/show/index',
        meta: {role: {needVerified: true}}
      },
      {
        name: 'showPayInfo',
        path: '/corporation/wechat/pay/show/index',
        meta: {role: {needVerified: true}}
      },
      {
        name: 'payInfo',
        path: '/corporation/wechat/pay/index',
        meta: {role: {needVerified: true}}
      },
      {
        name: 'CheckPersonList',
        path: '/corporation/wechat/monitor/check-person-table',
        meta: {role: {needVerified: true}}
      },
      {
        name: 'timeCardManage',
        path: '/corporation/wechat/time-card/index',
        meta: {role: {needVerified: true}}
      },

      // H5 应用
      {
        name: 'h5AppHome',
        path: '/corporation/h5app/index',
        meta: {role: {needMainUser: true, needVerified: true}}
      },
      {
        name: 'h5AppList',
        path: '/corporation/h5app/list',
        meta: {role: {needMainUser: true, needVerified: true}}
      },
      {
        name: 'h5AppReport',
        path: '/corporation/h5app/monitor/index',
        meta: {role: {needMainUser: true, needVerified: true}}
      },
      {
        name: 'h5appShow',
        path: '/corporation/h5app/info/show',
        meta: {role: {needMainUser: true, needVerified: true}}
      },
      {
        name: 'h5appDetail',
        path: '/corporation/h5app/info/index',
        meta: {role: {needMainUser: true, needVerified: true}}
      },

      // API 应用
      {
        name: 'apiAppHome',
        path: '/corporation/apiApp/index',
        meta: {role: {needMainUser: true, needVerified: true}}
      },
      {
        name: 'apiAppList',
        path: '/corporation/apiApp/list/index',
        meta: {role: {needMainUser: true, needVerified: true}}
      },
      {
        name: 'apiAppReport',
        path: '/corporation/apiApp/report/index',
        meta: {role: {needMainUser: true, needVerified: true}}
      },
      {
        name: 'apiAppDetail',
        path: '/corporation/apiApp/list/detail',
        meta: {role: {needMainUser: true, needVerified: true}}
      },
      {
        name: 'createApiApp',
        path: '/corporation/apiApp/list/create',
        meta: {role: {needMainUser: true, needVerified: true}}
      },
      {
        name: 'apiReportDetail',
        path: '/corporation/apiApp/report/detail',
        meta: {role: {needMainUser: true, needVerified: true}}
      },
      {
        name: 'apiFaceReportDetail',
        path: '/corporation/apiApp/report/face/detail',
        meta: {role: {needMainUser: true, needVerified: true}},
      },
      {
        name: 'apiCompositeReportDetail',
        path: '/corporation/apiApp/report/composite/detail',
        meta: {role: {needMainUser: true, needVerified: true}},
      },
      {
        name: 'apiV3ReportDetail',
        path: '/corporation/apiApp/report/v3/detail',
        meta: {role: {needMainUser: true, needVerified: true}},
      },
      // WinForm 应用
      {
        name: 'winFormAppHome',
        path: '/corporation/winFormApp/index',
        meta: {role: {needMainUser: true, needVerified: true}}
      },
      {
        name: 'winFormAppReport',
        path: '/corporation/winFormApp/monitor/index',
        meta: {role: {needVerified: true}}
      },
      // 商城应用
      {
        name: 'mallApp',
        path: '/corporation/mallApp/index',
        meta: {role: {needMainUser: true, needVerified: true}}
      },
      {
        name: 'mallAppEdit',
        path: '/corporation/mallApp/edit/index',
        meta: {role: {needMainUser: true, needVerified: true}}
      },
      {
        name: 'mallAppShow',
        path: '/corporation/mallApp/show/index',
        meta: {role: {needMainUser: true, needVerified: true}}
      },
      // 账号信息
      {
        name: 'myUserInfo',
        path: '/corporation/user/current',
        meta: {role: {}}
      },
      {
        name: 'corpCertification',
        path: '/corporation/certification/index',
        meta: {role: {needMainUser: true}}
      },
      {
        name: 'userManage',
        path: '/corporation/user/index',
        meta: {role: {needMainUser: true, needVerified: true}}
      },
      {
        name: 'corpInfo',
        path: '/corporation/certification/corpInfo',
        meta: {role: {needMainUser: true}}
      },
      {
        name: 'corpUserAdd',
        path: '/corporation/user/add',
        meta: {role: {needMainUser: true, needVerified: true}}
      },
      {
        name: 'bindWechat',
        path: '/corporation/user/bind-wechat/result',
        meta: {role: {}}
      },

      // 费用中心
      {
        name: 'costCenter',
        path: '/corporation/cost/index',
        meta: {role: {needMainUser: true, needVerified: true}}
      },
      {
        name: 'rechargeRecord',
        path: '/corporation/cost/rechargeRecord',
        meta: {role: {needMainUser: true, needVerified: true}}
      },
      {
        name: 'consumeRecord',
        path: '/corporation/cost/consumeRecord',
        meta: {role: {needMainUser: true, needVerified: true}}
      },
      {
        name: 'rechargeNow',
        path: '/corporation/cost/rechargeNow',
        meta: {role: {needMainUser: true, needVerified: true}}
      },
      {
        name: 'wechatAccountStatistic',
        path: '/corporation/cost/wechatAccountStatistic',
        meta: {role: {needMainUser: true, needVerified: true}}
      },

      // 页面装修
      {
        name: 'graphicBlock',
        path: '/corporation/decorate/graphicBlock/index',
        meta: {role: {needMainUser: true, needVerified: true}}
      },
      {
        name: 'mobileDecorateIndex',
        path: '/corporation/decorate/mobileDecorate/index',
        meta: {role: {needMainUser: true, needVerified: true}},
        children: [
          {
            name: 'mobileDecorate',
            path: '/corporation/decorate/mobileDecorate/:page',
            component: '/corporation/decorate/mobileDecorate/main/index',
            meta: {role: {needMainUser: true, needVerified: true}}
          },
          // 个人中心页面
          {
            name: 'myInfo',
            path: '/corporation/decorate/system/my',
            component: '/corporation/decorate/mobileDecorate/main/system/my',
            meta: {role: {needMainUser: true, needVerified: true}}
          },
          // 信息录入页面
          {
            name: 'infoEntry',
            path: '/corporation/decorate/system/infoEntry',
            component: '/corporation/decorate/mobileDecorate/main/system/info-entry/index',
            meta: {role: {needMainUser: true, needVerified: true}}
          },
          // 舌象拍摄检测页面
          {
            name: 'tongueCheck',
            path: '/corporation/decorate/system/tongueCheck',
            component: '/corporation/decorate/mobileDecorate/main/system/tongue-check',
            meta: {role: {needMainUser: true, needVerified: true}}
          },
          // 问诊页面
          {
            name: 'inquiry',
            path: '/corporation/decorate/system/inquiry',
            component: '/corporation/decorate/mobileDecorate/main/system/inquiry/index',
            meta: {role: {needMainUser: true, needVerified: true}}
          },
          // 检测记录列表页面
          {
            name: 'checkRecord',
            path: '/corporation/decorate/system/checkRecord',
            component: '/corporation/decorate/mobileDecorate/main/system/check-record/list',
            meta: {role: {needMainUser: true, needVerified: true}}
          },
          {
            name: 'checkResultTrend1',
            path: '/corporation/decorate/system/checkRecord/trend1',
            component: '/corporation/decorate/mobileDecorate/main/system/check-record/trend1',
            meta: {role: {needMainUser: true, needVerified: true}}
          },
          {
            name: 'checkResultTrend2',
            path: '/corporation/decorate/system/checkRecord/trend2',
            component: '/corporation/decorate/mobileDecorate/main/system/check-record/trend2',
            meta: {role: {needMainUser: true, needVerified: true}}
          },
          {
            name: 'checkResultTrend3',
            path: '/corporation/decorate/system/checkRecord/trend3',
            component: '/corporation/decorate/mobileDecorate/main/system/check-record/trend3',
            meta: {role: {needMainUser: true, needVerified: true}}
          },
          // 检测报告页面
          {
            name: 'checkResult',
            path: '/corporation/decorate/system/checkResult',
            component: '/corporation/decorate/mobileDecorate/main/system/check-result/index',
            meta: {role: {needMainUser: true, needVerified: true}}
          },
          // 舌象辨识页面
          {
            name: 'tongueRecognition',
            path: '/corporation/decorate/system/checkResult/tongueRecognition',
            component: '/corporation/decorate/mobileDecorate/main/system/check-result/TongueRecognition/index',
            meta: {role: {needMainUser: true, needVerified: true}}
          },
          // 面部望诊页面
          {
            name: 'faceRecognition',
            path: '/corporation/decorate/system/checkResult/faceRecognition',
            component: '/corporation/decorate/mobileDecorate/main/system/check-result/FaceRecognition/index',
            meta: {role: {needMainUser: true, needVerified: true}}
          },
          // 健康分析页面
          {
            name: 'healthAnalysis',
            path: '/corporation/decorate/system/checkResult/healthAnalysis',
            component: '/corporation/decorate/mobileDecorate/main/system/check-result/HealthAnalysis/index',
            meta: {role: {needMainUser: true, needVerified: true}}
          },
          // 健康分析-更多
          {
            name: 'SolarTermRegimenTips',
            path: '/solar/term/regimen/tips',
            component: '/corporation/decorate/mobileDecorate/main/system/check-result/SolarTermRegimenTips/index',
            meta: {role: {needMainUser: true, needVerified: true}}
          },
          // 调理方案页面
          {
            name: 'conditionPlan',
            path: '/corporation/decorate/system/checkResult/conditionPlan',
            component: '/corporation/decorate/mobileDecorate/main/system/check-result/ConditionPlan/index',
            meta: {role: {needMainUser: true, needVerified: true}}
          },
          // 图文块详情
          {
            name: 'graphicBlockPreview',
            path: '/corporation/decorate/graphicBlock/preview',
            meta: {role: {needMainUser: true, needVerified: true}}
          }
        ]
      },
      // 全局结论模板管理
      {
        name: 'globalResultConfig',
        path: '/corporation/info/resultConfig/index',
        meta: {role: {needMainUser: true, needVerified: true}}
      },

      // 医生代理
      {
        name: 'agentDoctor',
        path: '/corporation/agentDoctor/index',
        meta: {role: {needMainUser: true, needVerified: true}}
      },

      // 设备App
      {
        name: 'deviceApp',
        path: '/corporation/device/index',
        meta: {role: {needMainUser: true, needVerified: true}}
      },

      // 首页(旧)
      {
        name: 'dashboardOld',
        path: '/corporation/home/dashboardOld',
        meta: {role: {}}
      },

      // API应用记录(旧)
      {
        name: 'visceraRecord',
        path: '/corporation/record/viscera',
        meta: {role: {}}
      },
      {
        name: 'constitutionRecord',
        path: '/corporation/record/constitution',
        meta: {role: {}}
      },

      // H5应用记录(旧)
      {
        name: 'h5appRecordList',
        path: '/corporation/h5app/recordList',
        meta: {role: {}}
      },
      {
        name: 'h5appMemberList',
        path: '/corporation/h5app/memberList',
        meta: {role: {}}
      },

      // 微信应用记录(旧)
      {
        name: 'wxappRecordList',
        path: '/corporation/sp/wxapp/recordList',
        meta: {role: {}}
      },
      {
        name: 'wxappMemberList',
        path: '/corporation/sp/wxapp/memberList',
        meta: {role: {}}
      },

      // 企业信息(旧)
      {
        name: 'corpInfoOld',
        path: '/corporation/info/index',
        meta: {role: {}}
      },
      {
        name: 'corpUser',
        path: '/corporation/info/user/index',
        meta: {role: {}}
      },
      {
        name: 'corporationInfoAppShow',
        path: '/corporation/info/app/index',
        meta: {role: {}}
      },
      {
        name: 'corporationWxApp-base',
        path: '/corporation/info/app/sp/edit/baseInfo/index',
        meta: {role: {}}
      },
      {
        name: 'corporationWxApp-payInfo',
        path: '/corporation/info/app/sp/edit/payInfo/index',
        meta: {role: {}}
      },
      {
        name: 'corporationWxApp-bandWeChat',
        path: '/corporation/info/app/sp/edit/weChat/index',
        meta: {role: {}}
      },
      {
        name: 'corporationWxApp-bandWeChatSuccess',
        path: '/corporation/info/app/sp/edit/weChat/bandSuccess',
        meta: {role: {}}
      },
      {
        name: 'corporationWxApp-bandWeChat-show',
        path: '/corporation/info/app/sp/show/weChat/index',
        meta: {role: {}}
      },
      {
        name: 'corporationWxApp-base-show',
        path: '/corporation/info/app/sp/show/baseInfo/index',
        meta: {role: {}}
      },
      {
        name: 'corporationWxApp-payInfo-show',
        path: '/corporation/info/app/sp/show/payInfo/index',
        meta: {role: {}}
      },
      {
        name: 'corporationWxApp-statistic',
        path: '/corporation/info/accountStatistic',
        meta: {role: {}}
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/views/corporation/routes.js